
import React from 'react'
import Img from 'gatsby-image'
import ResponsiveMenu from 'react-responsive-navbar';
import Menu from './Menu'

class Header extends React.Component {
    render() {
        return (
            <section id="header-compact">
                <div className="inner">
                    <div className="image fit" style={{
                        maxWidth: 300,
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}>
                        <Img
                            className=""
                            sizes={this.props.headerImage.sizes}
                            alt="EMS Home Services, HVAC Services, Austin TX"
                        />
                    </div>
                    <Menu />
                </div>
            </section>
        )
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/CompactHeader.js